// removed by extract-text-webpack-plugin
module.exports = {"titleContainer":"_3sVqlre9cjln9gVM2ktTd0","title":"_2mSc8k5qfdia09E6v8WZCr","subtitle":"_1KTC1cBVWkyteHbNGp_vAI","image":"_2EOOGy0Yi0RKLkjlLzi7jw","informations":"_1tV5u6GhpTH_Fjjityp3vS","profilePic":"_1YGKcoVi5yBe2tMcNPWhb","empty":"_18NvWju4lDZpluOfpguNQG","loading":"_3lfqt19OhMXwNkj4j8aLmp","outfits":"_1rVBaXcUYOzGhAcU47WXTq","loader":"_10XAx-KuAFa0h4mlEKU9pw","load8":"_2rV5I7LZHTHZ30G-IMeF6H"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Discover/Discover.scss
 ** module id = 743
 ** module chunks = 0
 **/